import React, { Component, Fragment } from 'react'
import { getTermsAndConditionsPage } from 'api/content'
import { scrollToHash } from 'lib/window/scrollUtils'
import { Location } from 'history'
import HeadData from 'components/Common/HeadData'
import Heading from 'LuxKit/Typography/Heading'
import MarkdownRender from 'LuxKit/MarkdownRender'
import ErrorPage from 'components/Pages/ErrorPage'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import StaticContentPageContainer from 'components/Common/StaticContentPageContainer'

interface Props {
  slug: string;
  location: Location<any>
}

interface State {
  title: string;
  content: Array<any>;
  error: any;
}

class LegalPages extends Component<React.PropsWithChildren<Props>, State> {
  state: State = {
    title: '',
    content: [],
    error: undefined,
  }

  componentDidMount() {
    this.fetchContent()
  }

  fetchContent = () => {
    const { slug, location } = this.props
    getTermsAndConditionsPage(slug)
      .then(page => {
        if (!page || page.pageContent.length === 0) {
          return this.setState({ error: { status: 404 } })
        }
        return this.setState({
          title: page.title,
          content: page.pageContent,
        }, () => scrollToHash(location.hash, true))
      })
      .catch(error => this.setState({ error }))
  }

  render() {
    const { title, content, error } = this.state
    const loading = content.length === 0 && !error
    const errorStatus = error ? error.status : ''

    return (<>
      <HeadData title={title} />
      <StaticContentPageContainer>
        <VerticalSpacer gap={24}>
          <Heading variant="heading2" as="h1">{title}</Heading>
          {loading && <LoadingIndicator />}
          {errorStatus && <ErrorPage error={errorStatus} />}
          {!loading && content.map((term) => (
            <Fragment key={term.slug}>
              {!!term.title && <Heading id={term.slug} variant="heading3" format="uppercase" as="h2">{term.title}</Heading>}
              <MarkdownRender content={term.description} />
            </Fragment>
          ))}
        </VerticalSpacer>
      </StaticContentPageContainer>
    </>)
  }
}

export default LegalPages
